import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  HomeworkPreview,
  MODE,
} from '@grcs/views/shared/components/Homework/HomeworkPreview';
import { StudentCompletedEnhanced as StudentCompleted } from '@grcs/views/Student/StudentCompleted.enhanced';
import { StudentPendingEnhanced as StudentPending } from '@grcs/views/Student/StudentPending.enhanced';

export const StudentRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<StudentPending />} />
      <Route path="pending" element={<StudentPending />} />
      <Route
        path="pending/:homeworkId/:contentId"
        element={<HomeworkPreview mode={MODE.READING} />}
      />
      <Route path="completed" element={<StudentCompleted />} />
      <Route
        path="completed/:contentId"
        element={<HomeworkPreview mode={MODE.PREVIEW} />}
      />
    </Routes>
  );
};
